<template>
  <div class="flex items-center h-full py-1">
    <div class="flex-1 min-w-0">
      <div class="sensitive text-xs text-gray-900 truncate" :title="pharmacyName">
        {{ pharmacyName || '—' }}
      </div>
      <div
        v-if="pharmacyPhone"
        class="sensitive text-xs text-blue-600 cursor-pointer hover:underline"
        @click.stop="copyPhone"
        :title="'Click to copy ' + pharmacyPhone"
      >
        {{ formatPhone(pharmacyPhone) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MedAdherence_PharmacyCell',
  props: ['params'],
  computed: {
    pharmacyName() {
      return this.params.data?.pharmacy_name;
    },
    pharmacyPhone() {
      return this.params.data?.pharmacy_phone;
    }
  },
  methods: {
    formatPhone(phone) {
      if (!phone) return '';
      const digits = phone.replace(/\D/g, '');
      if (digits.length === 10) {
        return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
      }
      return phone;
    },
    copyPhone() {
      if (this.pharmacyPhone) {
        navigator.clipboard.writeText(this.pharmacyPhone.replace(/\D/g, ''));
      }
    }
  }
};
</script>
